import { useStyleConfig, chakra, forwardRef } from '@chakra-ui/react';
import { CustomCardProps } from 'theme/theme';

export interface CardProps extends CustomCardProps {
	elevation?: 'flat' | 'raised' | 'floating';
}

const CustomCard = forwardRef<CardProps, 'div'>((props, ref) => {
	const { size, variant, elevation, ...rest } = props;
	const resolvedVariant = variant || elevation;
	const styles = useStyleConfig('Card', { size, variant: resolvedVariant });

	return <chakra.div ref={ref} __css={styles} {...rest} />;
});

export default CustomCard;
